module.exports = __webpack_public_path__ + "img/stock4.a8ca03e0.png";